export default "__VITE_ASSET__BN5yMfxt__"